export default {
	DISPLAY_TYPE_FULL: 'full',
	DISPLAY_TYPE_SHORT: 'short',
	REGION_LIST_DELIMITER: '|',
	SINGLE_REGION_DELIMITER: '~'
};



// WEBPACK FOOTER //
// ./src/packages/country-selector/constants.ts